import { create } from 'zustand';

/**
 * Drawer open-state for Customer Support (overlay-drawers shell). Holds UI state only —
 * ticket data lives in TanStack Query. The listing stays open under the detail drawer so
 * the selected tab + scroll survive a round-trip into a ticket (story 101970 §6).
 */
type SupportDrawerState = {
  listOpen: boolean;
  openTicketId: string | null;
  /** Open the listing drawer (default tab = Active). */
  openList: () => void;
  /** Open a ticket's detail on top of the listing. */
  openTicket: (id: string) => void;
  /** Close the detail drawer, back to the listing. */
  closeTicket: () => void;
  /** Close both drawers (resets tab/scroll on next open). */
  closeAll: () => void;
};

export const useSupportStore = create<SupportDrawerState>((set) => ({
  listOpen: false,
  openTicketId: null,
  openList: () => set({ listOpen: true }),
  openTicket: (id) => set({ openTicketId: id }),
  closeTicket: () => set({ openTicketId: null }),
  closeAll: () => set({ listOpen: false, openTicketId: null }),
}));
